import * as actionTypes from "../action-types";

const initialState = {
    partnerDetails: null,
};

const partnerReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_PARTNER_DETAILS:
            return { ...state, partnerDetails: payload };

        default:
            return state;
    }
};

export default partnerReducer;